import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import reddelete from "../../../images/red-Delete.svg";

export default function DeleteModel({setDeleteModelShow , deleteModelShow, handelDelete , deletedData , type }) {
  return (
    <>
            {/* delete patient modal */}
            <Modal
              className="dlt-patient-modal"
              show={deleteModelShow}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              onHide={() => setDeleteModelShow(false)}
            >
              <Modal.Body>
                <div className="d-flex justify-content-center mb-3">
                  <div className="delete-img">
                    <img src={reddelete} alt="img"></img>
                  </div>
                </div>
                <h4>Are you sure? </h4>
                <p>You want to detele this {type}</p>
                <div className="authentication-btns d-flex justify-content-center gap-4">
                  <Button
                    className="btn border-btn outlined-btn btn-no outlined-btn"
                    onClick={() => setDeleteModelShow(false)}
                  >
                    No
                  </Button>
                  <Button
                    className="btn dark-btn btn-yes"
                    onClick={() => {handelDelete(deletedData) ; setDeleteModelShow(false)}}
                  >
                    Yes
                  </Button>
                </div>
              </Modal.Body>
            </Modal>    
    </>
  )
}
